import { render, staticRenderFns } from "./minScore.vue?vue&type=template&id=25555be8&scoped=true"
import script from "./minScore.vue?vue&type=script&lang=js"
export * from "./minScore.vue?vue&type=script&lang=js"
import style0 from "./minScore.vue?vue&type=style&index=0&id=25555be8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25555be8",
  null
  
)

export default component.exports